import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";

import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import Container from "components/Container/Container";
import PageHeader from "components/PageHeader/PageHeader";
import PageHeaderActions from "components/PageHeader/components/PageHeaderActions/PageHeaderActions";
import FullDataTable from "components/DataTable/FullDataTable";
import TableDefTasks from "table-defs/TableDefTasks";
import AddTaskModal from "./components/AddTaskModal/AddTaskModal";
import ViewTaskModal from "./components/ViewTaskModal/ViewTaskModal";
import useFilterRows from "helpers/customHooks/useFilterRows";
import ReactDOM from "react-dom";
import ConfirmationModal from "components/ConfirmationModal/ConfirmationModal";

import { loadTasksAction, deleteTaskAction, updateTaskAction, loadSitesAction, notifyTaskAction, loadUsersAction, completeTaskAction } from "store/actions/Actions";
import { setSelectedRows, toggleDropdowns } from "helpers/utils";

const Tasks = props => {
    const taskId = props.location.search.split("id=")[1];
    const dispatch = useDispatch();
    const DatatableReducer = useSelector((state) => state.DatatableReducer);
    const { loadSitesAction, loadTasksAction, loadUsersAction, SitesReducer, TasksReducer, UsersReducer, UserOrgSiteReducer } = props;

    const [state, setState] = useState({
        selectedRows: null,
        selected_sites: [],
    });

    const [showModal, setShowModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const renderConfirmModal = () => {
        return ReactDOM.createPortal(
            <ConfirmationModal
                data={showConfirmModal}
                setShowModal={setShowConfirmModal}
            />,
            document.getElementById('modal-root'),
        );
    };

    useEffect(() => {
        if (!SitesReducer.sites) {
            loadSitesAction();
        }
    }, [SitesReducer.sites, loadSitesAction]);

    useEffect(() => {
        if (!UsersReducer.users) {
            loadUsersAction();
        }
    }, [UsersReducer.users, loadUsersAction]);

    useEffect(() => {
        if (!TasksReducer.tasks && SitesReducer.sites && UsersReducer.users) {
            loadTasksAction();
        }
    }, [TasksReducer.tasks, SitesReducer.sites, UsersReducer.users, loadTasksAction]);

    const noFilters = {
        text: "",
        type: "",
        "last-action": "",
        status: "",
        role: "",
        site: "",
        selected_sites: [],
        start: "",
        end: "",
        dateField: "assigned"
    };

    const [filters, setFilters] = useState(
        (DatatableReducer.datatable && DatatableReducer.datatable.tasks && DatatableReducer.datatable.tasks.filters)
        ? DatatableReducer.datatable.tasks.filters
        : noFilters);

    const setFilter = filterName => e => {
        setFilters({
            ...filters,
            [filterName]:
                e.target.type === "checkbox"
                    ? e.target.checked
                    : e.target.value || ((e.target && e.target.attributes && e.target.attributes.value && e.target.attributes.value.value) || '')
        });
    };

    const searchFilter = props.location.search.split("filter=")[1];
    const sfCapitalized = searchFilter ? searchFilter.charAt(0).toUpperCase() + searchFilter.slice(1) : '';

    useEffect(() => {
        if (searchFilter === '') {
            setFilters((s) => ({
                ...s,
                type: "",
            }));
        } else {
            setFilters((s) => ({
                ...s,
                type: sfCapitalized || (DatatableReducer.datatable && DatatableReducer.datatable.tasks && DatatableReducer.datatable.tasks.filters && DatatableReducer.datatable.tasks.filters.type) || "",
            }));
        }
        window.history.replaceState(null, null, "/achieve/tasks")
    }, [searchFilter]);

    const setDateFilter = filterName => value => {
        setFilters({
            ...filters,
            [filterName]: value
        });
    };

    const onChangeRowSelect = ({ selectedRows }) => {
        if (selectedRows !== state.selectedRows) {
            setState(s => ({ ...s, selectedRows }));
        }
    };

    const filteredRows = useFilterRows(filters, TasksReducer.tasks);

    const [selectedTaskIds, setSelectedTasksIds] = useState(
        (DatatableReducer.datatable && DatatableReducer.datatable.tasks && DatatableReducer.datatable.tasks.selectedTaskIds)
        ? DatatableReducer.datatable.tasks.selectedTaskIds
        : []);

    useEffect(() => {
        dispatch({
            type: 'SET_DATATABLE',
            payload: {
                datatable: {
                    tasks: {
                        selectedTaskIds,
                        filters,
                        selectedRows: state.selectedRows,
                        selected_sites: state.selected_sites,
                    },
                },
            },
        });
    }, [selectedTaskIds, filters, state]);

    const actDropdownRef = React.createRef();
    const siteDropdownRef = React.createRef();
    const chooseActionDropdownRef = React.createRef();
    const typeDropdownRef = React.createRef();
    const statusDropdownRef = React.createRef();

    const handleComplete = (selectedTaskIds) => {
        const payload = selectedTaskIds.map(item => {
           return { ...item, completed: true }
        });
        props.completeTaskAction(payload);
    };

    const handleIncomplete = (selectedTaskIds) => {
        const payload = selectedTaskIds.map(item => {
           return { ...item, completed: false }
        });
        props.completeTaskAction(payload);
    };

    const handleDelete = (selectedTaskIds) => {
        props.deleteTaskAction(selectedTaskIds);
    };

    const handleNotify = (selectedTaskIds) => {
        props.notifyTaskAction(selectedTaskIds);
    };

    useEffect(() => {
        if (taskId && TasksReducer.tasks) {
            let tasks = TasksReducer.tasks.filter(task => task.id == taskId);
            if (tasks && tasks.length === 1){
                setShowViewModal(tasks[0]);
            }
        }
    }, [taskId, TasksReducer.tasks]);

    // const is_admin = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_admin) || false;
    const is_officer = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_officer) || false;
    const is_super = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_super) || false;

    const getSitesList = () => {
        try {
            const sitesList = SitesReducer.sites ? SitesReducer.sites.map(site => {
                return {
                    id: site.id,
                    siteName: site.name,
                    value: filters.selected_sites.includes(site.id) ? true : false
                }
            }) : [];
            sitesList.unshift({id: null, siteName: 'All Sites', value: filters.selected_sites.includes("") });
            return sitesList;
        } catch (error) {
            console.log('error with site list', error);
        }
        return [];
    };

    return (
        <AppLayoutWrapFull
            onClick={toggleDropdowns([
                chooseActionDropdownRef,
                typeDropdownRef,
                siteDropdownRef,
                actDropdownRef,
                statusDropdownRef
            ])}
        >
            <div id="modal-root"></div>
            <PageHeader showStats={true}>
                <PageHeaderActions
                    type={{
                        onChange: setFilter("type"),
                        options: ["All", "Remediation", "Attestation", "Question", "Miscellaneous"]
                    }}
                    typeDropdownRef={typeDropdownRef}
                    primaryButtonText="ADD TASK"
                    primaryButtonHandler={() => props.history.push(`/achieve/tasks/add`)}
                    searchHandler={e =>
                        setFilters({ ...filters, text: e.target.value || "" })
                    }
                    searchValue={filters.text}
                    chooseActionDropdownRef={chooseActionDropdownRef}
                    chooseAction={
                        (is_officer || is_super) ?
                        [
                            {
                                actionName: "Notify Selected",
                                actionHandler: () => handleNotify(selectedTaskIds)
                            },
                            {
                                actionName: "Mark Selected Complete",
                                actionHandler: () => handleComplete(selectedTaskIds)
                            },
                            {
                                actionName: "Mark Selected Incomplete",
                                actionHandler: () => handleIncomplete(selectedTaskIds)
                            },
                            {
                                actionName: "Delete Selected",
                                actionHandler: () => {
                                    
                                    const idCount = selectedTaskIds.length;

                                    if (idCount > 0) {
                                        setShowConfirmModal({
                                            title: 'Delete selected tasks',
                                            question: idCount === 1 ? 
                                                `Are you sure you want to delete the selected task?` : 
                                                `Are you sure you want to delete ${idCount} selected tasks?`,
                                            confirmAction: () => {
                                                handleDelete(selectedTaskIds);
                                            },
                                        });
                                    } else {
                                        setShowConfirmModal({
                                            type: 'simple',
                                            title: 'Nothing selected',
                                            question: `Please select tasks to be deleted.`,
                                        });
                                    }
                                }
                            }
                        ] : [
                            {
                                actionName: "Mark Selected Complete",
                                actionHandler: () => handleComplete(selectedTaskIds)
                            },
                            {
                                actionName: "Mark Selected Incomplete",
                                actionHandler: () => handleIncomplete(selectedTaskIds)
                            },
                            {
                                actionName: "Notify Selected",
                                actionHandler: () => handleNotify(selectedTaskIds)
                            },
                        ]
                    }
                    site={{
                        onClick: (e) => {
                            if (e.target.type === 'checkbox') {
                                let selected_sites = filters.selected_sites.slice();
                                if (e.target.checked) {
                                    selected_sites.push(e.target.value);
                                } else {
                                    selected_sites = selected_sites.filter(site => site !== e.target.value);
                                }
                                setFilters({
                                    ...filters,
                                    site: selected_sites.length > 0 ? `Sites (${selected_sites.length})` : 'Site',
                                    // site: "Site",
                                    selected_sites: selected_sites
                                });
                            }
                        },
                        sites: getSitesList(),
                    }}
                    siteDropdownRef={siteDropdownRef}
                    status={{
                        onChange: setFilter("status"),
                        options: ["All", "Complete", "Incomplete"]
                    }}
                    statusDropdownRef={statusDropdownRef}
                    dateRange={{
                        onChangeStart: setDateFilter("start"),
                        onChangeEnd: setDateFilter("end")
                    }}
                    filters={filters}
                    resetFilters={() => {
                        setFilters(noFilters);
                    }}
                />
            </PageHeader>
            <Container wide fluid>
                {TasksReducer.tasks &&
                <FullDataTable
                    onRowClick={function(e) {
                        if (
                            e.currentTarget.classList.contains("col-actions") ||
                            e.currentTarget.classList.contains("col-row-selector")
                        ) {
                            return;
                        }
                        // const task = TasksReducer.tasks.filter(task => task.id === this.props.rowData.id)[0];
                        // window.scrollTo({ top: 0, behavior: "smooth" });
                        // setShowViewModal(task);
                        props.history.push(`/achieve/tasks/edit/${this.props.rowData.id}`);
                    }}

                    rowsData={filteredRows}
                    definitions={TableDefTasks}
                    onChangeRowSelect={({ selectedRows }) => {
                        onChangeRowSelect({ selectedRows });
                    }
                        
                    }
                    customTableProps={
                        (is_officer || is_super) ?
                        {
                            // onNameClick: ({ rowData }) => console.log("NAME CLICK", rowData),
                            selectedRows: state.selectedRows,
                            viewTask: id => {
                                // console.log(id);
                                // props.history.push(`/maintain/tasks/edit?id=${id}`);
                            },
                            handleNotify: item => handleNotify([{ id: item.id }]),
                            handleComplete: item => handleComplete([{ id: item.id }]),
                            handleIncomplete: is_super ? item => handleIncomplete([{ id: item.id }]) : undefined,
                            handleDelete: ({ id, task }) => {
                                setShowConfirmModal({
                                    title: 'Delete the task',
                                    question: `Are you sure you want to remove the task "${task}"`,
                                    confirmAction: () => {
                                        handleDelete([{ id }]);
                                    },
                                });
                            }                          
                        } : {
                            // onNameClick: ({ rowData }) => console.log("NAME CLICK", rowData),
                            selectedRows: state.selectedRows,
                            viewTask: id => {
                                // console.log(id);
                                // props.history.push(`/maintain/tasks/edit?id=${id}`);
                            },
                            handleNotify: item => handleNotify([{ id: item.id }]),
                            handleComplete: item => handleComplete([{ id: item.id }]),
                            // handleIncomplete: item => handleIncomplete([{ id: item.id }]),
                            // handleDelete: item => handleDelete([{ id: item.id }])
                        }
                    }
                    setSelectedRows={setSelectedRows(["id"], setSelectedTasksIds)}
                />
                }
                {showConfirmModal && renderConfirmModal()}
            </Container>

            {showModal ? (
                <AddTaskModal
                    setShowModal={setShowModal}
                    id={taskId}
                />
            ) : null}

            {showViewModal ? (
                <ViewTaskModal
                    data={showViewModal}
                    setShowModal={setShowViewModal}
                />
            ) : null}
        </AppLayoutWrapFull>
    );
};

const mapStateToProps = (state) => ({
    TasksReducer: state.TasksReducer,
    UsersReducer: state.UsersReducer,
    SitesReducer: state.SitesReducer,
    UserOrgSiteReducer: state.UserOrgSiteReducer,
});

const mapDispatchToProps = {
    loadUsersAction,
    updateTaskAction,
    completeTaskAction,
    loadTasksAction,
    deleteTaskAction,
    notifyTaskAction,
    loadSitesAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Tasks);
